import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'

import type { IQuestionGroupActor } from 'modules/surveys/store/models/QuestionGroup'

interface Props {
  respondent: IQuestionGroupActor | null | undefined
}

export default function CommonEmployeeLabel({ respondent }: Props) {
  if (!respondent) return null

  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <UserAvatar
        size="s32"
        user={{ avatar: respondent.avatar ?? undefined, fullName: respondent.full_name ?? '' }}
      />
      <Text.Normal>{respondent.full_name ?? ''}</Text.Normal>
    </Box>
  )
}
